var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { State, Action, Selector } from '@ngxs/store';
import { ViewActions } from './view.actions';
import { LayoutDefault, LogoLayout, DrawerLayout } from '../models/view-layout.model';
import { Fullscreen } from 'src/app/shared/libraries/fullscreen/fullscreen';
import { TreeSearchDisplayMode } from 'src/app/shared/components/tree/tree-search/tree-search.component';
import { ViewLayoutStatus } from '../models/view-layout-status.enum';
import { LoaderTypeEnum } from '../models/loader-type.enum';
export class ViewStateModel {
}
export const initialLayout = {
    audio: new LayoutDefault(),
    camera: new LayoutDefault(ViewLayoutStatus.Show, true),
    chapterList: new LayoutDefault(ViewLayoutStatus.Show, false),
    column: new LayoutDefault(),
    description: new LayoutDefault(),
    drawer: new DrawerLayout(),
    fullscreen: new LayoutDefault(),
    help: new LayoutDefault(),
    labelInfo: new LayoutDefault(),
    labelList: new LayoutDefault(ViewLayoutStatus.Show, false),
    logo: new LogoLayout(),
    media: new LayoutDefault(),
    menu: new LayoutDefault(),
    nodeInfo: new LayoutDefault(ViewLayoutStatus.Hide, false),
    pagination: new LayoutDefault(),
    presenter: new LayoutDefault(ViewLayoutStatus.Hide, false),
    reset: new LayoutDefault(),
    search: new LayoutDefault(),
    toolbar: new LayoutDefault(),
    tools: new LayoutDefault(),
};
export const initialViewState = {
    breakpoint: null,
    labelsBreakpoint: 480,
    inputEnabled: true,
    fullscreenActive: false,
    presentationActive: false,
    drawerCoversContent: false,
    searchDisplayMode: TreeSearchDisplayMode.List,
    showNodeInfo: false,
    showHelp: false,
    loaderActive: false,
    loaderType: LoaderTypeEnum.Play,
    usePrintImage: false,
    multiPickModeEnabled: false,
    canHover: false,
    canTouch: false,
    canFullscreen: false,
    layout: initialLayout,
    initialLayout: initialLayout
};
let ViewState = class ViewState {
    // ---------- Selectors ----------
    static getLayout(state) {
        return state.layout;
    }
    static getInitialLayout(state) {
        return state.initialLayout;
    }
    static getBreakpoint(state) {
        return state.breakpoint;
    }
    static getLabelsBreakpoint(state) {
        return state.labelsBreakpoint;
    }
    static getInputEnabled(state) {
        return state.inputEnabled;
    }
    static getFullscreenActive(state) {
        return state.fullscreenActive;
    }
    static getPresentationActive(state) {
        return state.presentationActive;
    }
    static getDrawerCoversContent(state) {
        return state.drawerCoversContent;
    }
    static getShowNodeInfo(state) {
        return state.showNodeInfo;
    }
    static getShowHelp(state) {
        return state.showHelp;
    }
    static getLoaderActive(state) {
        return state.loaderActive;
    }
    static getLoaderType(state) {
        return state.loaderType;
    }
    static getCanTouch(state) {
        return state.canTouch;
    }
    static getCanHover(state) {
        return state.canHover;
    }
    static getMultiPickModeEnabled(state) {
        return state.multiPickModeEnabled;
    }
    static getSearchDisplayMode(state) {
        return state.searchDisplayMode;
    }
    static getUsePrintImage(state) {
        return state.usePrintImage;
    }
    // ---------- Actions ----------
    setLayout(context, action) {
        const layout = context.getState().layout;
        context.patchState({
            layout: Object.assign({}, layout, action.layout)
        });
    }
    setInitialLayout(context, { layout }) {
        context.patchState({
            initialLayout: layout
        });
    }
    setBreakpoint(context, action) {
        context.patchState({
            breakpoint: action.breakpoint
        });
    }
    setInputEnabled(context, action) {
        context.patchState({
            inputEnabled: action.enabled
        });
    }
    setCanHover(context, action) {
        context.patchState({
            canHover: action.canHover
        });
    }
    setCanTouch(context, action) {
        context.patchState({
            canTouch: action.canTouch
        });
    }
    setCanFullscreen(context, action) {
        context.patchState({
            canFullscreen: action.canFullscreen
        });
    }
    setSearchDisplayMode(context, action) {
        context.patchState({
            searchDisplayMode: action.mode
        });
    }
    toggleNodeInfo(context, action) {
        context.patchState({
            showNodeInfo: action.show
        });
    }
    togglePresentation(context, action) {
        context.patchState({
            presentationActive: action.active
        });
    }
    toggleHelp(context, action) {
        context.patchState({
            showHelp: action.show
        });
    }
    toggleLoader(context, action) {
        context.patchState({
            loaderActive: action.show
        });
    }
    setLoaderType(context, action) {
        context.patchState({
            loaderType: action.loaderType
        });
    }
    setMultiPickModeEnabled(context, action) {
        context.patchState({
            multiPickModeEnabled: action.enabled
        });
    }
    setLabelBreakpoint(context, action) {
        context.patchState({
            labelsBreakpoint: action.labelsBreakpoint
        });
    }
    setUsePrintImage(context, action) {
        context.patchState({
            usePrintImage: action.usePrintImage
        });
    }
    ngxsOnInit(context) {
        const fullscreen$ = Fullscreen.onFullscreenChange();
        fullscreen$.subscribe(event => {
            context.patchState({
                fullscreenActive: Fullscreen.isFullscreen()
            });
        });
    }
};
__decorate([
    Action(ViewActions.SetLayout),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, ViewActions.SetLayout]),
    __metadata("design:returntype", void 0)
], ViewState.prototype, "setLayout", null);
__decorate([
    Action(ViewActions.SetInitialLayout),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, ViewActions.SetInitialLayout]),
    __metadata("design:returntype", void 0)
], ViewState.prototype, "setInitialLayout", null);
__decorate([
    Action(ViewActions.SetBreakpoint),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, ViewActions.SetBreakpoint]),
    __metadata("design:returntype", void 0)
], ViewState.prototype, "setBreakpoint", null);
__decorate([
    Action(ViewActions.SetInputEnabled),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, ViewActions.SetInputEnabled]),
    __metadata("design:returntype", void 0)
], ViewState.prototype, "setInputEnabled", null);
__decorate([
    Action(ViewActions.SetCanHover),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, ViewActions.SetCanHover]),
    __metadata("design:returntype", void 0)
], ViewState.prototype, "setCanHover", null);
__decorate([
    Action(ViewActions.SetCanTouch),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, ViewActions.SetCanTouch]),
    __metadata("design:returntype", void 0)
], ViewState.prototype, "setCanTouch", null);
__decorate([
    Action(ViewActions.SetCanFullscreen),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, ViewActions.SetCanFullscreen]),
    __metadata("design:returntype", void 0)
], ViewState.prototype, "setCanFullscreen", null);
__decorate([
    Action(ViewActions.SetSearchDisplayMode),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, ViewActions.SetSearchDisplayMode]),
    __metadata("design:returntype", void 0)
], ViewState.prototype, "setSearchDisplayMode", null);
__decorate([
    Action(ViewActions.ToggleNodeInfo),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, ViewActions.ToggleNodeInfo]),
    __metadata("design:returntype", void 0)
], ViewState.prototype, "toggleNodeInfo", null);
__decorate([
    Action(ViewActions.TogglePresentation),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, ViewActions.TogglePresentation]),
    __metadata("design:returntype", void 0)
], ViewState.prototype, "togglePresentation", null);
__decorate([
    Action(ViewActions.ToggleHelp),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, ViewActions.ToggleHelp]),
    __metadata("design:returntype", void 0)
], ViewState.prototype, "toggleHelp", null);
__decorate([
    Action(ViewActions.ToggleLoader),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, ViewActions.ToggleLoader]),
    __metadata("design:returntype", void 0)
], ViewState.prototype, "toggleLoader", null);
__decorate([
    Action(ViewActions.SetLoaderType),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, ViewActions.SetLoaderType]),
    __metadata("design:returntype", void 0)
], ViewState.prototype, "setLoaderType", null);
__decorate([
    Action(ViewActions.SetMultiPickModeEnabled),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, ViewActions.SetMultiPickModeEnabled]),
    __metadata("design:returntype", void 0)
], ViewState.prototype, "setMultiPickModeEnabled", null);
__decorate([
    Action(ViewActions.SetLabelBreakpoint),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, ViewActions.SetLabelBreakpoint]),
    __metadata("design:returntype", void 0)
], ViewState.prototype, "setLabelBreakpoint", null);
__decorate([
    Action(ViewActions.SetUsePrintImage),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, ViewActions.SetUsePrintImage]),
    __metadata("design:returntype", void 0)
], ViewState.prototype, "setUsePrintImage", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [ViewStateModel]),
    __metadata("design:returntype", void 0)
], ViewState, "getLayout", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [ViewStateModel]),
    __metadata("design:returntype", void 0)
], ViewState, "getInitialLayout", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [ViewStateModel]),
    __metadata("design:returntype", void 0)
], ViewState, "getBreakpoint", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [ViewStateModel]),
    __metadata("design:returntype", void 0)
], ViewState, "getLabelsBreakpoint", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [ViewStateModel]),
    __metadata("design:returntype", void 0)
], ViewState, "getInputEnabled", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [ViewStateModel]),
    __metadata("design:returntype", void 0)
], ViewState, "getFullscreenActive", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [ViewStateModel]),
    __metadata("design:returntype", void 0)
], ViewState, "getPresentationActive", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [ViewStateModel]),
    __metadata("design:returntype", void 0)
], ViewState, "getDrawerCoversContent", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [ViewStateModel]),
    __metadata("design:returntype", void 0)
], ViewState, "getShowNodeInfo", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [ViewStateModel]),
    __metadata("design:returntype", void 0)
], ViewState, "getShowHelp", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [ViewStateModel]),
    __metadata("design:returntype", void 0)
], ViewState, "getLoaderActive", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [ViewStateModel]),
    __metadata("design:returntype", void 0)
], ViewState, "getLoaderType", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [ViewStateModel]),
    __metadata("design:returntype", void 0)
], ViewState, "getCanTouch", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [ViewStateModel]),
    __metadata("design:returntype", void 0)
], ViewState, "getCanHover", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [ViewStateModel]),
    __metadata("design:returntype", void 0)
], ViewState, "getMultiPickModeEnabled", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [ViewStateModel]),
    __metadata("design:returntype", void 0)
], ViewState, "getSearchDisplayMode", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [ViewStateModel]),
    __metadata("design:returntype", void 0)
], ViewState, "getUsePrintImage", null);
ViewState = __decorate([
    State({
        name: 'view',
        defaults: initialViewState
    })
], ViewState);
export { ViewState };
